<div class="mtn-title">
    <p>{{data.title}}</p>
</div>
    {{data.content}}
<div class='button'>
    <button mat-button class="btn2" type="button" mat-dialog-close  (click)='onBack()'>OK</button>
</div> 